import {
  rtkApi,
  GET_TEACHER_TERMS,
  GET_TEACHER_TERM_MODULES,
  GET_TEACHER_TERM_STUDENTS,
} from '@/shared/api';
import { SuccessApiResponse } from '@/shared/types/common';
import {
  ITeacherTermsRequest,
  ITeacherTermsResponse,
  ITeacherTermModulesRequest,
  ITeacherTermModulesResponse,
  ITeacherTermStudentsRequest,
  ITeacherTermStudentsResponse,
} from './types';

const teacherTermsApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    // GET /teacher/intakes/{intakeId}/terms
    getTeacherTerms: build.query<ITeacherTermsResponse, ITeacherTermsRequest>({
      query: ({ intakeId }) => `/teacher/intakes/${intakeId}/terms`,
      transformResponse: (response: SuccessApiResponse<ITeacherTermsResponse>) => response.data,
      providesTags: [GET_TEACHER_TERMS],
    }),

    // GET /teacher/groups/{groupNumber}/terms/{intakeTermId}/modules
    getTeacherTermModules: build.query<ITeacherTermModulesResponse, ITeacherTermModulesRequest>({
      query: ({ groupNumber, intakeTermId, ...params }) => ({
        url: `/teacher/groups/${groupNumber}/terms/${intakeTermId}/modules`,
        params,
      }),
      transformResponse: (response: SuccessApiResponse<ITeacherTermModulesResponse>) =>
        response.data,
      providesTags: [GET_TEACHER_TERM_MODULES],
    }),

    // GET /teacher/groups/{groupNumber}/terms/{intakeTermId}/students
    getTeacherTermStudents: build.query<ITeacherTermStudentsResponse, ITeacherTermStudentsRequest>({
      query: ({ groupNumber, intakeTermId, ...params }) => ({
        url: `/teacher/groups/${groupNumber}/terms/${intakeTermId}/students`,
        params,
      }),
      transformResponse: (response: SuccessApiResponse<ITeacherTermStudentsResponse>) =>
        response.data,
      providesTags: [GET_TEACHER_TERM_STUDENTS],
    }),
  }),
});

export const {
  useGetTeacherTermsQuery,
  useGetTeacherTermModulesQuery,
  useGetTeacherTermStudentsQuery,
} = teacherTermsApi;
